// Texte, die noch vom Kunden kommen. Alles, was mit "Platzhalter" beginnt, vor dem
// Go-live ersetzen oder löschen (leere Einträge werden nicht angezeigt).

// "Gut zu wissen": Startseite und Kontaktseite.
export const GOOD_TO_KNOW = [
    ["Parken", "Gegenüber am und auf dem Festplatz"],
    ["Barrierefrei", "Mit Aufzug"],
    ["Bezahlen", "Karte und bar"],
    ["Kinder", "Eigene Kinderkarte"],
];

// Über uns: die Familie hinter dem Restaurant.
export const FAMILY = {
    story: [
        "Platzhalter: Seit wann gibt es das En Edem, wo kommt die Familie her, wie kam es zum Restaurant? Zwei bis drei Sätze.",
        "Platzhalter: Wer macht was – wer steht am Grill, wer im Service? Was ist der Familie in der Küche wichtig?",
    ],
};

// Feiern: Eckdaten. Werte mit "Platzhalter" bitte durch echte Zahlen ersetzen.
export const EVENT_FACTS = [
    ["Feste", "bis 200 Personen"],
    ["Terrasse", "groß"],
    ["Menü oder Buffet", "nach Absprache"],
    ["Für Kinder", "Eigene Kinderkarte"],
];

// Feiern: Beispiel-Angebote als Orientierung.
export const EVENT_OFFERS = [
    {
        title: "Meze-Buffet",
        text: "Platzhalter: Was gehört dazu? Z. B. Tzatziki, Saganaki, Dolmadakia, Calamari, Salate, Pita.",
        price: "Platzhalter: ab xx € pro Person",
    },
    {
        title: "Grill-Buffet",
        text: "Platzhalter: Was gehört dazu? Z. B. Lammkoteletts, Gyros, Bifteki, Beilagen, Salate.",
        price: "Platzhalter: ab xx € pro Person",
    },
    {
        title: "Menü am Tisch",
        text: "Platzhalter: Drei Gänge, z. B. Vorspeisenteller, Hauptgang nach Wahl, Dessert.",
        price: "Platzhalter: ab xx € pro Person",
    },
];

// Startseite: Gutscheine. Nur Hinweis, dass es sie gibt (kein Online-Kauf, keine Vorbestellung).
export const VOUCHER_FACTS = [
    ["Wert", "frei wählbar, ab 10 €"],
    ["Gestaltung", "Platzhalter: hochwertige Klappkarte im Umschlag"],
    ["Erhältlich", "bei uns im Restaurant"],
];

// Footer: Social-Media-Links. Ohne url wird der Name als Platzhalter angezeigt.
export const SOCIAL = [
    { name: "Instagram", url: "https://www.instagram.com/en_edem._/" },
    { name: "Facebook", url: "https://www.facebook.com/En-Edem-zur-G%C3%A4rtnerklause-104267908501134" },
];
